"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 8,
    '&.disabled': {
      opacity: theme.disabledOpacity,
      cursor: 'default',
      '& $item': {
        color: theme.pagination.itemColor,
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        '&:hover': {
          cursor: 'default'
        }
      },
      '& $item.active': {
        color: theme.pagination.itemActiveColor,
        backgroundColor: theme.pagination.itemActiveBgColor,
        borderColor: theme.pagination.itemActiveBorderColor
      },
      '& $icon': {
        color: theme.pagination.iconColor,
        '&:hover': {
          color: theme.pagination.iconColor,
          cursor: 'default'
        }
      }
    },
    '&.hidden': {
      display: 'none'
    }
  },
  label: {
    fontSize: theme.pagination.fontSize,
    lineHeight: '19px',
    padding: '2px 0 3px 0',
    flex: '1 0 auto',
    textAlign: 'right',
    '& .range': {
      fontWeight: theme.pagination.fontWeightSemibold
    }
  },
  input: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flex: '1 1 auto',
    marginLeft: 20,
    '& $field': {
      maxWidth: 76,
      padding: 0,
      flex: '1 1 20px'
    },
    '& > span': {
      userSelect: 'none'
    }
  },
  field: {
    minWidth: 40
  },
  selectPerPage: {
    display: 'flex',
    flex: '0 0 auto',
    position: 'relative'
  },
  menu: {
    position: 'absolute',
    bottom: 20,
    right: 0,
    minWidth: 100
  },
  pagination: {
    flex: '0 0 auto',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    '&.hidden': {
      display: 'none'
    }
  },
  iconNext: {
    display: 'flex',
    '& $icon': {
      transform: 'rotate(-180deg)'
    }
  },
  iconPrev: {
    display: 'flex'
  },
  icon: {
    padding: '5px 8px',
    display: 'flex',
    color: theme.pagination.iconColor,
    transition: theme.transition(['all']),
    '&:hover': {
      color: theme.pagination.iconHoverColor,
      cursor: 'pointer'
    },
    '&.disabled': {
      opacity: 0.5,
      pointerEvents: 'none',
      color: theme.pagination.iconColorDisabled
    },
    '&.active': {
      transform: 'rotate(-180deg)',
      '& .fill': {
        fill: theme.pagination.iconHoverColor
      }
    }
  },
  list: {
    flex: '1 1 auto',
    display: 'flex',
    alignItems: 'center'
  },
  item: {
    flex: '0 0 auto',
    minWidth: 24,
    height: 24,
    boxSizing: 'border-box',
    borderRadius: '4px',
    color: theme.pagination.itemColor,
    textAlign: 'center',
    verticalAlign: 'center',
    borderColor: 'transparent',
    borderWidth: 1,
    borderStyle: 'solid',
    fontSize: theme.pagination.fontSize,
    lineHeight: '19px',
    fontWeight: 600,
    padding: '1px 0 2px 0',
    userSelect: 'none',
    '&:hover': {
      cursor: 'pointer',
      color: theme.pagination.itemHoverColor,
      backgroundColor: theme.pagination.itemHoverBgColor,
      borderColor: theme.pagination.itemHoverBorderColor
    },
    '&.active': {
      color: theme.pagination.itemActiveColor,
      backgroundColor: theme.pagination.itemActiveBgColor,
      borderColor: theme.pagination.itemActiveBorderColor,
      '&:hover': {
        cursor: 'default'
      }
    },
    '&.disabled': {
      color: theme.pagination.itemColor,
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      '&:hover': {
        cursor: 'default'
      }
    }
  }
});

exports.default = _default;